<template>
      <!-- 导航栏 -->      
      <div class="nav-container">
        <ul class="navbar">
          <li class="item"
            v-for='(item, index) in this.navItems'
            v-bind:key='item.id'
            v-on:click='setActiveItem(item)'
            v-bind:class="{'sortactive': item.id == currentItem.id, 'sortnormal' : item.id != currentItem.id}">
            <a>{{item.name}}</a>
          </li>
        </ul>
      </div>
</template>

<script>
export default {
  name: 'Navbar',
  data() {
    return {
      currentItem: {},  //当前选中的排序
      // navItems:[],

    };
  },
  // props: ['navItems'],
  props: {
      // navItems: [{ name: 'item name', id: 0 }]
      navItems: {
        type : Array,
        required : true,
        default : ()=>[]
      }
  },

  created() {
    this.currentItem = (this.navItems === undefined) ? [] : this.navItems[0];
    // console.log("Navbar.vue/created/navItems.name="+this.navItems[0].name)
  },
  methods: {
		/*
		 * 设置当前点击的选项
		 * @param: item 当前选中的item
		*/
		setActiveItem(item) {
			this.currentItem = item;
      console.log("Navbar.vue/setActiveItem/return this.currentItem"
        +" id="+this.currentItem.id
        // +" key="+this.currentItem.key
        +" name="+this.currentItem.name
        // +" value="+this.currentItem.value
      );
			this.$emit('changeItem', this.currentItem);
		}
  }
};
</script>

<style lang="scss" scoped>
	.nav-container {
		width: 100%;
    // 横向可滚动
    overflow-x: auto;
    white-space: nowrap;
		ul.navbar{
			display: flex;
			width: auto;
			justify-content: space-around;
			align-content: center;
    	align-items: center;
    	border: 0px;
			border-top: 1px solid #E8EAED;
    	border-bottom: 1px solid #E8EAED;
    	li{
    		font-size: 14px;
    		color: #4E545D;
    		border-bottom: 2px solid transparent;
    		position: relative;
    		flex-basis: 100px;
        text-align: center;
        height: 42px;
			  padding: 0px 4px;
			  line-height: 42px;
			  a {
			  	height: 42px;
			  	display: inline-block;
			  }
        img {
          height: 4px;
          width: 8px;
          vertical-align: middle;
        }
    	}
    	li.sortactive {
    		border-bottom-color: $primaryColor;
    		a {
    			color: $primaryColor;
    		}
    	}
    	li.sortnormal {
    		border-bottom-color: transparent;
    		a {
    			color: #4E545D;
    		}
    	}
    	.arrow-icon {
    		width: 12px;
    		height: 12px;
    	}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/common/Navbar.vue